import script from "./ParentConnector.vue?vue&type=script&lang=ts&setup=true"
export * from "./ParentConnector.vue?vue&type=script&lang=ts&setup=true"

import "./ParentConnector.vue?vue&type=style&index=0&id=08d3ac3b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08d3ac3b"]])

export default __exports__